import apiClient, { unwrap } from './client'
import type { LoginResponse } from './types'

/** 滑块拼图验证码挑战（后端 /auth/captcha 生成） */
export interface CaptchaChallenge {
  token: string
  background_svg: string
  piece_svg: string
  piece_width: number
  piece_height: number
  y: number
}

export const authApi = {
  login(username: string, password: string, captchaToken: string, captchaX: number) {
    return unwrap<LoginResponse>(
      apiClient.post('/auth/login', {
        username,
        password,
        captcha_token: captchaToken,
        captcha_x: captchaX,
      }),
    )
  },

  async captcha(): Promise<CaptchaChallenge> {
    return unwrap<CaptchaChallenge>(apiClient.get('/auth/captcha'))
  },

  async health() {
    const res = await apiClient.get('/health')
    return res.data as { status: string; version: string; timestamp: string }
  },
}
